import {useTranslation} from "react-i18next";
import {Link, useParams} from "react-router-dom";
import useEventProgram from "../../hooks/useEventProgram";
import SectionProgram from "./Program/SectionProgram";

export default function Author({ id }) {
    const { t } = useTranslation();
    const { authorId } = useParams();
    const [programData, dispatch] = useEventProgram(id);

    if (!programData) {
        return null;
    }

    const author = programData.authors[authorId];

    return (
        <div className="tab-panel active" id="authors">
            <div className={'author-info'}>
                <div className="sub-breadcrumbs js-return-to-authorsList">
                    <ul>
                        <li><Link to={`/conference/${id}/speakers`}><i className="icon-back" />{ t('conferences.conference.toAuthors') }</Link></li>
                    </ul>
                </div>
                <div className="js-author-info">
                    <div>
                        <div className="flex-center author-block">
                            {author.image !== null && <div className="author-photo"><img src={author.image} className="img-fill" alt="" /></div>}
                            <div className="author-content">
                                <p className="name">{author.lastName} {author.firstName} {author.middleName}</p>
                                <p>{author.workplace}</p>
                            </div>
                        </div>
                        { !!author.description && <><h5>{ t('conferences.conference.aboutAuthor') }</h5><p dangerouslySetInnerHTML={{__html: author.description}} /></> }
                        <h5>{ t('conferences.conference.authorReportList') }</h5>
                        <div className="js-sections-conference">
                            <SectionProgram
                                sections={author.sections}
                                reports={programData.reports}
                                dispatch={dispatch}
                                id={id}
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    )
}
